import type { MouseEventHandler } from 'react';

import React from 'react';

import type { ListItemButtonProps } from '../../List';

import { ListItemButton } from '../../List';
import { useMenuContext } from '../Menu';

export type MenuItemButtonProps = ListItemButtonProps;

/**
 * Same as ListItemButton, just allows manipulation of dropdown through context
 */
const MenuItemButton = (props: MenuItemButtonProps) => {
  const { multiple, setOpen } = useMenuContext();

  const handleClick: MouseEventHandler<HTMLDivElement> = React.useCallback(
    (e) => {
      if (props.onClick) props.onClick(e);
      if (!multiple) setOpen((state) => !state);
    },
    [props, multiple, setOpen],
  );

  return <ListItemButton {...props} onClick={handleClick} />;
};

export default MenuItemButton;
